import { useMemo } from 'react';
import { getLocaleWeekdays } from '../utils/weekdayUtils';
export default function useLocaleWeekdays(intl) {
    return useMemo(function () { return getLocaleWeekdays(intl); }, [intl]);
}
